module.exports = __webpack_public_path__ + "img/photo1_1.2e040096.jpg";